import { TrendingUp } from 'lucide-react'

interface StatCardProps {
    title: string
    value: string | number
    icon: any
    color: 'blue' | 'green' | 'purple' | 'yellow'
}

const colorMap: Record<string, { bg: string, text: string }> = {
    'blue': { bg: 'bg-[#001c28]', text: 'text-[#d4a94d]' },
    'green': { bg: 'bg-green-100', text: 'text-green-700' },
    'purple': { bg: 'bg-purple-100', text: 'text-purple-700' },
    'yellow': { bg: 'bg-yellow-100', text: 'text-yellow-700' },
}

export const StatCard = ({ title, value, icon: Icon, color }: StatCardProps) => {
    const styles = colorMap[color] || { bg: 'bg-gray-100', text: 'text-gray-700' }

    return (
        <div className="bg-white p-8 rounded-[2.5rem] border border-[#001c28]/5 shadow-xl shadow-[#001c28]/5 group hover:-translate-y-1 transition-all duration-500">
            <div className="flex items-center justify-between mb-4">
                <div className={`p-4 rounded-2xl ${styles.bg} ${styles.text} bg-opacity-10`}>
                    <Icon className="w-6 h-6" />
                </div>
                <TrendingUp className="w-4 h-4 text-[#001c28]/20" />
            </div>
            <p className="text-[10px] font-black text-[#001c28]/40 uppercase tracking-widest">{title}</p>
            <h3 className="text-3xl font-black text-[#001c28] mt-1 tracking-tighter italic">{value}</h3>
        </div>
    )
}

interface FinancialSummaryCardsProps {
    stats: {
        totalBookings: number
        totalRevenue: number
        confirmedBookings: number
        pendingPayments: number
        canceledBookings: number
    } | null
    loading: boolean
}

import { Calendar, DollarSign, PieChart, Clock } from 'lucide-react'

export default function FinancialSummaryCards({ stats, loading }: FinancialSummaryCardsProps) {
    if (loading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {[1, 2, 3, 4].map(n => <div key={n} className="h-40 bg-[#001c28]/5 rounded-[2.5rem] animate-pulse" />)}
            </div>
        )
    }

    if (!stats) return null

    const confirmationRate = stats.totalBookings > 0
        ? ((stats.confirmedBookings / stats.totalBookings) * 100).toFixed(1)
        : '0.0'

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <StatCard title="Total de Reservas" value={stats.totalBookings} icon={Calendar} color="blue" />
            <StatCard title="Receita Total" value={`R$ ${stats.totalRevenue.toFixed(2)}`} icon={DollarSign} color="green" />
            <StatCard title="Taxa de Confirmação" value={`${confirmationRate}%`} icon={PieChart} color="purple" />
            <StatCard title="Pagamentos Pendentes" value={stats.pendingPayments} icon={Clock} color="yellow" />
        </div>
    )
}
